import { render, staticRenderFns } from "./JiangsuMobileElm02.vue?vue&type=template&id=56cbac67&scoped=true"
import script from "./JiangsuMobileElm02.vue?vue&type=script&lang=js"
export * from "./JiangsuMobileElm02.vue?vue&type=script&lang=js"
import style0 from "./JiangsuMobileElm02.vue?vue&type=style&index=0&id=56cbac67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbac67",
  null
  
)

export default component.exports